import LoadingDom from "@/components/UI/LoadingDom";
import ReactDOM from "react-dom/client";
let loadingCount = 0;

/**
 * 显示加载动画的函数
 * @param isAdd - 是否添加加载动画
 * @param callback - 可选的回调函数，在loadingCount为0时执行
 */
export const showLoading = (isAdd?: boolean, callback?: () => void) => {
  if (loadingCount === 0) {
    callback?.();
    if (isAdd) {
      const dom = document.createElement("div");
      dom.setAttribute("id", "loading");
      document.getElementById("layout").appendChild(dom);
      ReactDOM.createRoot(dom).render(<LoadingDom isLoading />);
    }
  }
  loadingCount++;
};

export const hideLoading = (callback?: () => void) => {
  if (loadingCount <= 0) return;
  loadingCount--;
  if (loadingCount === 0) {
    callback?.();
    const loadDom = document.getElementById("loading");
    if (loadDom) {
      document.getElementById("layout").removeChild(document.getElementById("loading") as HTMLElement);
    }
  }
};
